import { gql, TypedDocumentNode } from '@apollo/client'
import { employeesSidebarEmployeeFragment } from './employeesSidebarEmployeeFragment'
import type { SuEmployeesWithMissingSafetyAnswersSidebarQuery } from './__generated__/SuEmployeesWithMissingSafetyAnswersSidebarQuery'

export const suEmployeesWithMissingSafetyAnswersSidebarQuery: TypedDocumentNode<SuEmployeesWithMissingSafetyAnswersSidebarQuery> = gql`
  ${employeesSidebarEmployeeFragment}

  query SuEmployeesWithMissingSafetyAnswersSidebarQuery {
    suEmployeesWithMissingSafetyAnswers {
      ...EmployeesSidebarEmployeeFragment
    }
  }
`
